import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Offcanvas } from '@/entities/offcanvas'
import { UserCard } from '@/entities/user/user-card/UserCard'
import { useRouteOffcanvas } from '@/shared/hooks/use-route-offcanvas'
import { useCurrentUser } from '@/widgets/user-widget'

export const Route = createFileRoute('/_auth/users/apk/list/$userId')({
  staticData: {
    meta: {
      title: 'Пользователь АПК',
      description: '',
    },
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { isOpen, close } = useRouteOffcanvas()
  const { t } = useTranslation()

  const { currentUser } = useCurrentUser()
  return (
    <Offcanvas open={isOpen} onClose={close} title={t('Карточка пользователя АПК')}>
      <UserCard user={currentUser} />
    </Offcanvas>
  )
}
